import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createStyles, makeStyles } from '@material-ui/core';
import { monolithEmbeddedStarts, monolithEmbeddedStartsM, monolithLStarts, monolithMStart, } from './EmbeddedSignUpTypes';
var useStyles = makeStyles(function (_a) {
    var _b, _c, _d;
    var spacing = _a.spacing, typography = _a.typography, palette = _a.palette;
    return createStyles({
        terms: {
            fontFamily: typography.fontFamily,
            fontSize: typography.caption.fontSize,
            color: palette.border.main,
            textAlign: function (_a) {
                var hideCaptchaTerms = _a.hideCaptchaTerms;
                return (hideCaptchaTerms ? 'center' : 'start');
            },
            '& a': (_b = {
                    display: 'inline',
                    fontWeight: typography.fontWeightBold,
                    fontSize: spacing(1.5),
                    textDecoration: 'none',
                    color: palette.secondary.main,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                _b["@media (min-width:" + monolithMStart + "px)"] = {
                    display: 'inline-block',
                },
                _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                    display: 'inline',
                },
                _b["@media (min-width:" + monolithLStarts + "px)"] = {
                    display: 'inline-block',
                },
                _b),
        },
        terms_loh: {
            fontFamily: typography.fontFamily,
            fontSize: typography.caption.fontSize,
            color: palette.border.disabled,
            textAlign: function (_a) {
                var hideCaptchaTerms = _a.hideCaptchaTerms;
                return (hideCaptchaTerms ? 'center' : 'start');
            },
            '& p': (_c = {},
                _c["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                    minWidth: 262,
                },
                _c["@media (min-width:" + monolithLStarts + "px)"] = {
                    minWidth: 298,
                },
                _c),
            '& a': (_d = {
                    display: 'inline',
                    fontWeight: typography.fontWeightBold,
                    fontSize: spacing(1.5),
                    textDecoration: 'none',
                    color: palette.border.disabled,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                _d["@media (min-width:" + monolithMStart + "px)"] = {
                    display: 'inline-block',
                },
                _d["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                    display: 'inline',
                },
                _d["@media (min-width:" + monolithLStarts + "px)"] = {
                    display: 'inline-block',
                },
                _d),
        },
    });
});
export function SignUpTerms(props) {
    var _a = props.hideCaptchaTerms, hideCaptchaTerms = _a === void 0 ? false : _a, _b = props.isLoggedOutHome, isLoggedOutHome = _b === void 0 ? false : _b;
    var classes = useStyles(props);
    var googleTermsOfServiceContainer = function (text) { return (React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://policies.google.com/terms" }, text)); };
    var googlePrivacyPolicyContainer = function (text) { return (React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://policies.google.com/privacy" }, text)); };
    var termsOfServiceContainer = function (text) { return (React.createElement("a", { target: "_blank", href: "/terms" }, text)); };
    var privacyPolicyContainer = function (text) { return (React.createElement("a", { target: "_blank", href: "/privacy" }, text)); };
    return (React.createElement("p", { className: isLoggedOutHome ? classes.terms_loh : classes.terms },
        React.createElement(FormattedMessage, { id: "authentication.sign-up-terms.compliance-message", description: "Text at the bottom of the signup form indicating that the user is agreeing to our terms of service and privacy policy", defaultMessage: "By signing up you agree to Skillshare's{blankSpace}", values: { blankSpace: '\u00A0' }, "data-testid": "authentication-sign-up-terms-compliance-message" }),
        isLoggedOutHome ? React.createElement("br", null) : '',
        React.createElement(FormattedMessage, { id: "authentication.sign-up-terms.skillshare-terms-privacy-policy", description: "Text at the bottom of the signup form indicating that the user is agreeing to our terms of service and privacy policy, with links to those policies.", defaultMessage: "<termsOfServiceContainer>Terms of Service</termsOfServiceContainer>{blankSpace}and{blankSpace}<privacyPolicyContainer>Privacy Policy.</privacyPolicyContainer>", values: {
                blankSpace: '\u00A0',
                termsOfServiceContainer: termsOfServiceContainer,
                privacyPolicyContainer: privacyPolicyContainer,
            }, "data-testid": "authentication-sign-up-terms-skillshare-terms-privacy-policy" }),
        !hideCaptchaTerms && (React.createElement(React.Fragment, null,
            React.createElement(FormattedMessage, { id: "authentication.sign-up-terms.captcha", description: "Text that appears below the signup form indicating that a Google Captcha is being used in the form.", defaultMessage: "{blankSpace}This page is protected by reCAPTCHA and is subject to Google's{blankSpace}<termsOfServiceContainer>Terms of Service</termsOfServiceContainer>{blankSpace}and{blankSpace}<privacyPolicyContainer>Privacy Policy.</privacyPolicyContainer>", values: {
                    blankSpace: '\u00A0',
                    termsOfServiceContainer: googleTermsOfServiceContainer,
                    privacyPolicyContainer: googlePrivacyPolicyContainer,
                }, "data-testid": "authentication-sign-up-terms-captcha" })))));
}
//# sourceMappingURL=SignUpTerms.js.map